import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "icon"]
  static values = {
    portal: { type: Boolean, default: true }
  }

  connect() {
    this.originalParent = null
    // Store direct reference to menu element (needed because portaling moves it outside controller)
    this.menu = this.menuTarget
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    document.addEventListener("click", this.handleDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    // Ensure menu is returned to original position
    if (this.portalValue && this.originalParent && this.menu.parentElement === document.body) {
      this.originalParent.appendChild(this.menu)
    }
  }

  handleDocumentClick(event) {
    const isOpen = !this.menu.classList.contains("hidden")
    if (!isOpen) return

    // Check if click is inside the dropdown element or menu
    const clickedInside = this.element.contains(event.target) ||
                          this.menu.contains(event.target)

    if (!clickedInside) {
      this.close()
    }
  }

  toggle() {
    if (this.menu.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    const menu = this.menu
    const button = this.element.querySelector('button') || this.element
    const rect = button.getBoundingClientRect()

    // Portal to body only if enabled (default: true)
    if (this.portalValue) {
      this.originalParent = menu.parentElement
      document.body.appendChild(menu)

      // Position menu with fixed positioning
      menu.style.position = 'fixed'
      menu.style.right = `${window.innerWidth - rect.right}px`
      menu.style.left = 'auto'
    }

    // Show menu
    menu.classList.remove("hidden")

    if (this.portalValue) {
      // Calculate available space and position
      const menuHeight = menu.offsetHeight
      const viewportHeight = window.innerHeight
      const spaceBelow = viewportHeight - rect.bottom
      const spaceAbove = rect.top

      if (spaceBelow < menuHeight && spaceAbove > spaceBelow) {
        menu.style.top = 'auto'
        menu.style.bottom = `${viewportHeight - rect.top + 4}px`
      } else {
        menu.style.top = `${rect.bottom + 4}px`
        menu.style.bottom = 'auto'
      }
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }
  }

  close() {
    const menu = this.menu
    menu.classList.add("hidden")

    if (this.portalValue) {
      menu.style.position = ''
      menu.style.top = ''
      menu.style.bottom = ''
      menu.style.right = ''
      menu.style.left = ''

      if (this.originalParent) {
        this.originalParent.appendChild(menu)
        this.originalParent = null
      }
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }
  }
}
